var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "topfixed", staticStyle: { "font-size": "14px" } },
    [
      _c(
        "div",
        { staticStyle: { height: "40px", "background-color": "#f5f5f5" } },
        [
          _c(
            "div",
            { staticClass: "contain-box", staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "padding-right": "20px",
                    "line-height": "40px",
                    "font-family": "PingFang SC",
                    "font-weight": "400",
                    "font-size": "12px",
                    color: "#666"
                  }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  !_vm.userInfo.id
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "20px",
                            cursor: "pointer"
                          },
                          on: { click: _vm.toLogin }
                        },
                        [_vm._v("登录/注册")]
                      )
                    : _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "20px",
                            cursor: "pointer"
                          },
                          on: { click: _vm.logout }
                        },
                        [_vm._v("退出登录")]
                      )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    flex: "1",
                    display: "flex",
                    "font-family": "PingFang SC",
                    "font-weight": "400",
                    "font-size": "12px",
                    color: "#55575E"
                  }
                },
                [
                  _c("div", { staticStyle: { flex: "1" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "justify-content": "end" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "line-height": "40px",
                            "margin-right": "10px"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    path: "/home/index"
                                  })
                                }
                              }
                            },
                            [_vm._v("大有网首页")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({ path: "/car" })
                                }
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-shopping-cart-2",
                                staticStyle: { "margin-right": "5px" }
                              }),
                              _vm._v("购物车")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              staticStyle: { "margin-right": "20px" },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    path: "/personal/myCollect"
                                  })
                                }
                              }
                            },
                            [_vm._v("收藏夹")]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "top-title",
                              on: { click: _vm.toUserInfo }
                            },
                            [_vm._v("个人中心")]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            height: "100px",
            "line-height": "100px",
            "background-color": "#f5f5f5"
          }
        },
        [
          _c(
            "div",
            { staticClass: "contain-box", staticStyle: { display: "flex" } },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    width: "200px",
                    height: "100px",
                    display: "flex",
                    "align-items": "center"
                  },
                  on: {
                    click: function($event) {
                      return _vm.selMenu(2)
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: {
                      cursor: "pointer",
                      width: "110px",
                      height: "58px"
                    },
                    attrs: { src: _vm.logo }
                  })
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "top-title" }, [
      _vm._v("欢迎来到"),
      _c("span", {}, [_vm._v("大有网")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1477df20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1477df20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/top.vue
// module id = null
// module chunks = 